export { default } from '../components/svg';
export type { SVGProps } from '../types';
